import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/guide-index.png'
import _imports_1 from '@/assets/images/off-icon.png'
import _imports_2 from '@/assets/images/guide-index-wx-share.png'
import _imports_3 from '../../assets/activity/pages/right.svg'
import _imports_4 from '../../assets/activity/pages/join-people-1.png'
import _imports_5 from '../../assets/activity/pages/join-people-2.png'
import _imports_6 from '../../assets/activity/pages/join-people-33.png'
import _imports_7 from '../../assets/activity/pages/join-people-3.png'
import _imports_8 from '../../assets/activity/pages/addOne.png'
import _imports_9 from '../../assets/activity/pages/join-null.png'
import _imports_10 from '../../assets/activity/pages/poster.png'
import _imports_11 from '../../assets/activity/pages/weixin.png'
import _imports_12 from '../../assets/activity/pages/copy.png'
import _imports_13 from '@/assets/images/QRCode-OA.png'


const _withScopeId = n => (_pushScopeId("data-v-09f80614"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "off-icon",
  src: _imports_1
}, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "off-icon",
  src: _imports_1
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "container-layout" }
const _hoisted_8 = { class: "container-top" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "getBookStatusSuccess" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "getBookStatus-title-success" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "right",
      src: _imports_3,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createTextVNode(" 已完成拼团，恭喜！ ")
], -1))
const _hoisted_12 = { class: "getBookStatus-content-success" }
const _hoisted_13 = { class: "content-wrapper-avatar-success" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-wrapper-avatar-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-wrapper-avatar-item content-wrapper-avatar-two" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })
], -1))
const _hoisted_17 = {
  key: 0,
  class: "content-wrapper-avatar-item content-wrapper-avatar-three"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "content-wrapper-avatar-item content-wrapper-avatar-three"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "container-layout" }
const _hoisted_24 = { class: "top-wrapper" }
const _hoisted_25 = {
  key: 0,
  class: "icon-wrapper"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "getBookStatus" }
const _hoisted_29 = {
  key: 0,
  class: "getBookStatus-title"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "right",
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 1,
  class: "getBookStatus-content"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "content-wrapper" }
const _hoisted_37 = { class: "content-wrapper-title" }
const _hoisted_38 = { class: "content-wrapper-avatar" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-wrapper-avatar-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_40 = {
  key: 0,
  class: "content-wrapper-avatar-item content-wrapper-avatar-two"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 1,
  class: "content-wrapper-avatar-item content-wrapper-avatar-two"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-wrapper-avatar-item content-wrapper-avatar-three" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: ""
  })
], -1))
const _hoisted_47 = { class: "people-number" }
const _hoisted_48 = { class: "gap-number" }
const _hoisted_49 = { class: "last-time" }
const _hoisted_50 = { class: "last-time-block" }
const _hoisted_51 = { class: "last-time-block" }
const _hoisted_52 = { class: "last-time-block" }
const _hoisted_53 = { class: "last-time-block" }
const _hoisted_54 = { class: "content-footer" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "分享给朋友，完成拼团", -1))
const _hoisted_56 = { style: {"margin-top":"-10px"} }
const _hoisted_57 = { class: "last-time" }
const _hoisted_58 = { class: "last-time-block" }
const _hoisted_59 = { class: "last-time-block" }
const _hoisted_60 = { class: "last-time-block" }
const _hoisted_61 = { class: "last-time-block" }
const _hoisted_62 = { class: "popup-content" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-content-item-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    alt: ""
  })
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "领取海报", -1))
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = ["data-clipboard-text"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-content-item-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发给朋友", -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = ["data-clipboard-text"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-content-item-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    alt: ""
  })
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制链接", -1))
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = ["src"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "poster-intro" }, "已生成专属海报，长按图片分享海报", -1))
const _hoisted_76 = { class: "poster" }
const _hoisted_77 = { id: "imgBox" }
const _hoisted_78 = ["src"]
const _hoisted_79 = {
  style: {},
  class: "notify-content"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您尚未关注公众号，无法接收通知", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"5px"} }, "请关注公众号后再回到这里", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"30px"} }, "长按扫码关注公众号", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: "PPtutor公众号二维码"
}, null, -1))

import { onMounted, reactive, ref, unref } from "vue";
import { WxTicket } from "@/api/wxTicket";
import { Button, Popup, Toast, Loading, Dialog } from "vant";
import { useRoute } from "vue-router";
import html2canvas from "html2canvas";
import { getCookie } from "@/utils/service/request";
import ClipboardJS from "clipboard";
import {
  Activity,
  GroupShareResponse,
  startGroupResponse,
} from "@/api/activity";
import {
  initConfig,
  updateAppMessageShareData,
  updateTimelineShareData,
  getUserAuthorize,
} from "@/hooks/useWxSDK";
import { useClipboard } from "@vueuse/core";
import { mobileModels } from "@/utils/mobileModels";
import QrcodeVue from "qrcode.vue";
import useShare from "./hooks/useShare";
import { isAuto } from "html2canvas/dist/types/render/background";
//CSS 接口
type Cls = {
  isDisplay: boolean;
};

interface BoolInfoState {
  bookName: string;
  coverUrl: string;
  previewList: Array<string>;
}

interface JsonType {
  title: string;
  content: string;
}
interface BeginGuideBtnType {
  btnName: string;
  url: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'getSuccess',
  props: {
    pid: {}
  },
  setup(__props: any) {

const OA_URL = ref<string>(
  "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU3MDY1ODQ5OA==&scene=124#wechat_redirect"
);

const VanDialog = Dialog.Component;
const showDialog = ref<boolean>(false);

const cssFlag: Cls = reactive({
  isDisplay: false,
});
const props = __props;

const isSuccess = ref<boolean>(false);
const isFailed = ref<boolean>(false);
const showShareRef = ref<boolean>(false);
const wechatStatus = ref<boolean>(false); //微信状态
const wechatShareStatus = ref<boolean>(false); //微信分享状态
// const mkBenefitsPackageBookRef = ref<Array<mkBenefitsPackageBookResponse>>([]);

// const options = [{ name: "微信", icon: "wechat" }];
const source = ref<string>("");

const route = useRoute();
const { isWeixin } = useShare();

const { aid, login, code, state, isLogin } = route.query;
source.value = `${process.env.VUE_APP_WX_URL}/bookgroupdisplay/?aid=${aid}&pid=${props.pid}`;
console.log(source.value);

const dataInfo = reactive<startGroupResponse>({
  id: 0,
  endTime: 0, //	结束时间(时间戳)
  activitySharePosterUrl: "", //	开始组团页  分享海报
  activityShareBtn: "", //活动分享按钮
  openGroupExplain: "", //开团说明
  openGroupText: "", //开团文案
  beginGuideBtn: "", //活动分享按钮 按钮名称
  successGuideBtn: "",
  totalMember: 0, //总共的参团人数
  joinMember: 0, //参加的人数
  bannerUrls: "",
  openGroupSuccessUrl: "", //组团成功提示图片
});
const shareInfo = reactive<GroupShareResponse>({
  id: 0, //id
  shareTitle: "", //分享标题
  shareText: "", //分享文本
  shareImgUrl: "", //分享图片
});

const openGroupTextArr = ref<Array<JsonType>>([]); //开团文案
const openGroupTextArrNewUser = ref<Array<string>>([]); //新用户开团文案内容
const openGroupTextTitleNewUser = ref<string>(""); //新用户开团文案标题
const openGroupTextArrOldUser = ref<Array<string>>([]); //老用户开团文案内容
const openGroupTextTitleOldUser = ref<string>(""); //老用户开团文案标题

const beginGuideBtnObj = ref<BeginGuideBtnType>({
  btnName: "",
  url: "",
});
const successGuideBtnObj = ref<BeginGuideBtnType>({
  btnName: "",
  url: "",
});
const bannerUrlsArr = ref<Array<string>>([]);

//计算倒计时
const d = ref<number>();
const h = ref<number>(0);
const m = ref<number>(0);
const s = ref<number>(0);
const getTimeFunc = () => {
  //获取当前时间
  let nowTime = new Date().getTime();
  const time = new Date(dataInfo.endTime);
  // console.log(time)
  const end = time.getTime();
  //时间差
  let gapTime = end - nowTime;
  // console.log(gapTime)
  if (gapTime >= 0) {
    d.value = Math.floor(gapTime / 1000 / 60 / 60 / 24);
    h.value = Math.floor((gapTime / 1000 / 60 / 60) % 24);
    m.value = Math.floor((gapTime / 1000 / 60) % 60);
    s.value = Math.floor((gapTime / 1000) % 60);
  }
};
setInterval(getTimeFunc, 1000);

const flag = ref<boolean>(false);

const isTeamHimSelfIn = ref<boolean>(false);

const onSelect = (value: string) => {
  show.value = false;

  if (value === "复制链接") {
    const { copy, isSupported, text, copied } = useClipboard({
      source,
      read: true,
    });
    copy();
    console.log(isSupported, text, copied);

    Toast("复制成功");
  }
  if (value === "发给朋友") {
    if (!isWeixin()) {
      const { copy, isSupported, text, copied } = useClipboard({
        source,
        read: true,
      });
      copy();
      console.log(isSupported, text, copied);
      Toast("复制成功"); //不是微信就复制链接
    } else {
      wechatShareStatus.value = true;
    }
  }
};
function OffWechatBgClick() {
  wechatStatus.value = false;
  (document.querySelector("body") as HTMLBodyElement).style.overflowY = "auto";
}

function OffWechatShareClick() {
  wechatShareStatus.value = false;
  (document.querySelector("body") as HTMLBodyElement).style.overflowY = "auto";
}

//打开App
function openApp() {
  // wechatStatus.value = isWeixin();
  // console.log(wechatStatus.value);
  // if (wechatStatus.value) {
  //   (document.querySelector("body") as HTMLBodyElement).style.overflowY =
  //     "hidden";
  // } else {
  // let brand = mobileModels(navigator.userAgent.toLowerCase());
  // if (["iPad", "iphone"].includes(brand)) {
  //   window.open(
  //     "https://apps.apple.com/us/app/pptutor%E4%B8%AD%E6%96%87/id1548091746"
  //   );
  // } else if (brand === "huawei") {
  //   window.open("https://appgallery.huawei.com/app/C103636233");
  // } else {
  //安卓打开谷歌
  //   window.open(
  //     "https://play.google.com/store/apps/details?id=com.pptutor_lite"
  //   );
  // }
  window.open(`${beginGuideBtnObj.value.url}`);
  // }
}
function openSuccessApp() {
  window.open(`${successGuideBtnObj.value.url}`);
}
function setCookie(cookiename: any, cookievalue: any) {
  const date = new Date();
  // if (type === 'milsecond') {
  //   date.setTime(date.getTime() + milsecond)
  // } else {
  date.setDate(date.getDate() + 99999);
  // }
  document.cookie =
    cookiename +
    "=" +
    cookievalue +
    ";expires = " +
    date.toUTCString() +
    ";path=/";
}
let openGroupExplainArr = ref<Array<string>>([]);
onMounted(async () => {
  const { aid, isLogin, isAuto } = route.query;
  setCookie("aid", aid);
  const xxx = String(isLogin);

  console.log(xxx);

  const yyy = String(isAuto);

  isTeamHimSelfIn.value = yyy === "true" ? true : false;

  if (xxx === "false") {
    flag.value = false; //老用户
  } else {
    flag.value = true; //新用户
  }
  try {
    const res = await Activity.startGroupDataGet({ id: Number(aid) });
    dataInfo.id = res.id;
    dataInfo.bannerUrls = res.bannerUrls;
    dataInfo.endTime = res.endTime;
    dataInfo.activitySharePosterUrl = res.activitySharePosterUrl;
    dataInfo.activityShareBtn = res.activityShareBtn;
    dataInfo.openGroupExplain = res.openGroupExplain;

    openGroupExplainArr.value = dataInfo.openGroupExplain.split("#");

    dataInfo.openGroupText = res.openGroupText;
    dataInfo.beginGuideBtn = res.beginGuideBtn;
    dataInfo.successGuideBtn = res.successGuideBtn;

    dataInfo.totalMember = res.totalMember; //组团成功需要的人数
    dataInfo.joinMember = res.joinMember; //参与组团的人数
    if (dataInfo.joinMember >= dataInfo.totalMember - 1) {
      isSuccess.value = true;
    } else {
      isFailed.value = true;
    }
    dataInfo.openGroupSuccessUrl = res.openGroupSuccessUrl; //参与组团的人数

    openGroupTextArr.value = JSON.parse(dataInfo.openGroupText);

    console.log(openGroupTextArr.value);

    openGroupTextArrNewUser.value =
      openGroupTextArr.value[0].content.split("#");

    openGroupTextTitleNewUser.value = openGroupTextArr.value[0].title;

    console.log("新用户文案", openGroupTextTitleNewUser.value);

    openGroupTextArrOldUser.value =
      openGroupTextArr.value[1].content.split("#");

    openGroupTextTitleOldUser.value = openGroupTextArr.value[1].title;

    console.log("老用户文案", openGroupTextTitleOldUser.value);

    beginGuideBtnObj.value = JSON.parse(dataInfo.beginGuideBtn);
    successGuideBtnObj.value = JSON.parse(dataInfo.successGuideBtn);
    bannerUrlsArr.value = dataInfo.bannerUrls.split(",");
  } catch (error) {
    console.log("报错了报错了报错了");
    console.log(error);
  }

  try {
    const resShare = await Activity.groupShare({ id: Number(aid) });
    shareInfo.shareTitle = resShare.shareTitle;
    shareInfo.shareText = resShare.shareText;
    shareInfo.shareImgUrl = resShare.shareImgUrl;
  } catch (error) {
    console.log(error);
  }

  try {
    //判断是不是微信
    if (isWeixin()) {
      try {
        // 获取订阅状态
        const res = await Activity.getSubscriptionStatus({
          userId: Number(props.pid),
        });
        if (!res.isSub) {
          // 获取用户授权 weChat
          if (!code) {
            console.log(window.location.href);
            const redirectUri = encodeURIComponent(window.location.href);
            getUserAuthorize(
              process.env.VUE_APP_WX_APP_ID as string,
              redirectUri
            );
            return;
          }
          // 请求订阅通知
          setTimeout(async () => {
            const result = await Dialog.confirm({
              message: "请允许通知\n" + "朋友参与后我们会通知您",
              theme: "round-button",
            });
            if (result === "confirm") {
              const res = await Activity.subscriptionNotify({
                userId: Number(props.pid),
                code: code as string,
              });
              if (!res.isSubscriptionOA) {
                showDialog.value = true;
              } else {
                await Dialog.alert({
                  message: "订阅通知成功",
                });
              }
            }
          }, 1000 * 3);
        }
      } catch (e) {
        console.log(e);
      }
      const { ticket } = await WxTicket.getWxTicket();
      await initConfig(
        {
          appId: process.env.VUE_APP_WX_APP_ID as string,
          timestamp: parseInt(String(new Date().getTime() / 1000)), //时间戳
          nonceStr: "asdfaskldjflkajskd", //随机字符串
        },
        ticket,
        window.location.href
      );
      const shareParams = {
        title: shareInfo.shareTitle, // 分享标题
        desc: shareInfo.shareText, // 分享描述
        link: source.value, //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareInfo.shareImgUrl, //分享图标
        success() {
          // 用户确认分享后执行的回调函数
          console.log("success");
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          console.log("cancel");
        },
      };
      console.log({
        title: shareInfo.shareTitle, // 分享标题
        desc: shareInfo.shareText, // 分享描述
        link: source.value, //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareInfo.shareImgUrl, //分享图标
      });
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      updateAppMessageShareData(shareParams);
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      updateTimelineShareData(shareParams);
    }
  } catch (error) {
    console.log(error);
  }
});

const show = ref<boolean>(false);
const showPoster = ref<boolean>(false);
const shareClickBtn = () => {
  show.value = true;
};
const imgBox = ref<InstanceType<typeof Popup> | null>(null);
const shareImage = ref<string>("");
const getPoster = () => {
  show.value = false;
  showPoster.value = true;
  const shareImageHeight = (document as any).querySelector(
    "#imgBox>img"
  ).clientHeight;
  console.log(shareImageHeight);
  html2canvas((document as any).getElementById("imgBox"), {
    width: window.innerWidth,
    height: shareImageHeight,
    useCORS: true,
  }).then(function (canvas) {
    shareImage.value = canvas.toDataURL();
  });
};
const clipboard = new ClipboardJS(".copy-link");

clipboard.on("success", function (e) {
  console.info("Action:", e.action);
  console.info("Text:", e.text);
  console.info("Trigger:", e.trigger);
  Toast("复制成功"); //不是微信就复制链接

  e.clearSelection();
});

clipboard.on("error", function (e) {
  console.error("Action:", e.action);
  console.error("Trigger:", e.trigger);
});

const clipboardWeixin = new ClipboardJS(".copy-weixin-link");

clipboardWeixin.on("success", function (e) {
  console.info("Action:", e.action);
  console.info("Text:", e.text);
  console.info("Trigger:", e.trigger);
  if (!isWeixin()) {
    Toast("复制成功"); //不是微信就复制链接
  } else {
    wechatShareStatus.value = true;
  }

  e.clearSelection();
});

clipboardWeixin.on("error", function (e) {
  console.error("Action:", e.action);
  console.error("Trigger:", e.trigger);
});

function refresh() {
  window.location.href =
    window.location.origin +
    window.location.pathname +
    `?aid=${aid}&isLogin=${isLogin}&isAuto=true}`;
}

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (wechatStatus.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wechat-background",
          onClick: OffWechatBgClick
        }, _hoisted_3))
      : _createCommentVNode("", true),
    (wechatShareStatus.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "wechat-background",
          onClick: OffWechatShareClick
        }, _hoisted_6))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          src: dataInfo.openGroupSuccessUrl,
          alt: ""
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", null, _toDisplayString(_unref(openGroupExplainArr)[0]), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(openGroupExplainArr)[1]), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", null, [
              (dataInfo.totalMember === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            ])
          ]),
          _createElementVNode("div", {
            class: "getBookStatus-footer-success",
            onClick: openSuccessApp
          }, _toDisplayString(successGuideBtnObj.value.btnName), 1)
        ])
      ])
    ], 512), [
      [_vShow, isSuccess.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (isTeamHimSelfIn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          (!isTeamHimSelfIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                (!flag.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(openGroupTextTitleNewUser.value), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(openGroupTextTitleOldUser.value), 1))
              ]))
            : _createCommentVNode("", true),
          (!isTeamHimSelfIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (!flag.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openGroupTextArrNewUser.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openGroupTextArrOldUser.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                      }), 128))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (beginGuideBtnObj.value.btnName && !isTeamHimSelfIn.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "get-book-status-footer",
                onClick: openApp
              }, _toDisplayString(beginGuideBtnObj.value.btnName), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("p", null, _toDisplayString(_unref(openGroupExplainArr)[0]), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(openGroupExplainArr)[1]), 1)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", null, [
            (dataInfo.joinMember !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
          ]),
          _hoisted_46
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createTextVNode(" 已有 "),
          _createElementVNode("span", null, _toDisplayString(dataInfo.joinMember + 1), 1),
          _createTextVNode("人，还差 "),
          _createElementVNode("span", _hoisted_48, _toDisplayString(dataInfo.totalMember - 1 - dataInfo.joinMember), 1),
          _createTextVNode("人，加油！ ")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_49, [
            _createTextVNode(" 剩余 "),
            _createElementVNode("span", _hoisted_50, _toDisplayString(d.value), 1),
            _createTextVNode(" 天 "),
            _createElementVNode("span", _hoisted_51, _toDisplayString(h.value), 1),
            _createTextVNode(" : "),
            _createElementVNode("span", _hoisted_52, _toDisplayString(m.value), 1),
            _createTextVNode(": "),
            _createElementVNode("span", _hoisted_53, _toDisplayString(s.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_unref(Button), {
          class: "help-button",
          onClick: shareClickBtn,
          block: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(dataInfo.activityShareBtn), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_popup, {
        round: "",
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
        closeable: "",
        position: "bottom",
        overlay: "",
        style: { height: '35%' }
      }, {
        default: _withCtx(() => [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createTextVNode(" 剩余 "),
              _createElementVNode("span", _hoisted_58, _toDisplayString(d.value), 1),
              _createTextVNode(" 天 "),
              _createElementVNode("span", _hoisted_59, _toDisplayString(h.value), 1),
              _createTextVNode(" : "),
              _createElementVNode("span", _hoisted_60, _toDisplayString(m.value), 1),
              _createTextVNode(": "),
              _createElementVNode("span", _hoisted_61, _toDisplayString(s.value), 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_62, [
            _createElementVNode("li", {
              class: "popup-content-item",
              onClick: getPoster
            }, _hoisted_65),
            _createElementVNode("li", {
              class: "popup-content-item copy-weixin-link",
              "data-clipboard-text": source.value
            }, _hoisted_69, 8, _hoisted_66),
            _createElementVNode("li", {
              class: "popup-content-item copy-link",
              "data-clipboard-text": source.value
            }, _hoisted_73, 8, _hoisted_70)
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_van_popup, {
        closeable: "",
        show: showPoster.value,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showPoster).value = $event)),
        round: "",
        "close-on-click-overlay": false,
        style: {"background-color":"transparent","min-width":"50%","min-height":"50%"}
      }, {
        default: _withCtx(() => [
          (shareImage.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("img", {
                  src: shareImage.value,
                  alt: "",
                  class: "share-image"
                }, null, 8, _hoisted_74),
                _hoisted_75
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          _createVNode(QrcodeVue, {
            value: source.value,
            size: 54,
            level: "H",
            class: "qr-activity",
            id: "canvasDom"
          }, null, 8, ["value"]),
          _createElementVNode("img", {
            src: dataInfo.activitySharePosterUrl,
            crossOrigin: "anonymous",
            alt: ""
          }, null, 8, _hoisted_78)
        ])
      ])
    ], 512), [
      [_vShow, isFailed.value]
    ]),
    _createVNode(_unref(VanDialog), {
      show: showDialog.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      theme: "round-button",
      confirmButtonText: "先看看，暂不关注",
      id: "notify-container",
      "show-confirm-button": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_79, [
          _hoisted_80,
          _hoisted_81,
          _hoisted_82,
          _hoisted_83,
          _createVNode(_unref(Button), {
            class: "oa-button",
            onClick: refresh,
            round: "",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 我已关注 ")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "close-notify",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showDialog.value = false)),
            block: "",
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 先看看，暂不关注 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})